/*
Gloves, Cone Strainers, Mixing STicks, Wood Fillers, Razor Blades
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Gloves, Cone Strainers, Mixing Sticks, Wood Fillers, Razor Blades'
const id = 'DuY0zo5ybOm9BoyvCTu6'

export default {
  name,
  id,
  filters,
  headers,
  form
}
